import React from 'react'
import SliderTopResult from '../../component/slidercomponent/SliderTopResult'

const HomeTopResult = () => {
    return (
        <>
            <div >
                <section className="result" >
                    <div className="container">
                        <div className="sec-title text-center mb-3" data-aos="fade-up" data-aos-duration={1000}>
                            <h2>Top Result</h2>
                            <div className="divider">
                                <span className="fa fa-mortar-board" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="result-box" >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Student Name</th>
                                                <th scope="col">Class</th>
                                                <th scope="col">Percentage</th>
                                                <th scope="col">Session</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Himanshu Mishra</td>
                                                <td>12th</td>
                                                <td>91%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Anand Kumar Gautam </td>
                                                <td>12th</td>
                                                <td>87%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Khushi Kushwaha </td>
                                                <td>12th</td>
                                                <td>86.6% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Swasti Tripathi </td>
                                                <td>12th</td>
                                                <td>84.4%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Mahek Sondhiya </td>
                                                <td>12th</td>
                                                <td>79.8%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Prakash Soni (Maths)</td>
                                                <td>12th</td>
                                                <td>93%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Kanhaiya Gupta (Comm.)</td>
                                                <td>12th</td>
                                                <td>87.2%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Vivek Sondhiya (Bio)</td>
                                                <td>12th</td>
                                                <td> 85%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td> Shivendra Singh (Bio)</td>
                                                <td>12th</td>
                                                <td>84.6%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            
                                            <tr>
                                                <td> Arin Tripathi (Maths)</td>
                                                <td>12th</td>
                                                <td> 84.4%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td> Shreya Shukla (Bio)</td>
                                                <td>12th</td>
                                                <td>84.4%</td>
                                                <td>2023-24</td>
                                            </tr>

<tr>
                                                <td>Aakriti Thakur </td>
                                                <td>10th</td>
                                                <td>93.2%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Deepanshu Kesharwani </td>
                                                <td>10th</td>
                                                <td>92.8% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Krishna Kushwaha </td>
                                                <td>10th</td>
                                                <td>92.2% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Sagar Saket </td>
                                                <td>10th</td>
                                                <td>90.4% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Subha Mishra </td>
                                                <td>10th</td>
                                                <td>89.4% </td>
                                                <td>2024-25</td>
                                            </tr>

                                            <tr>
                                                <td>Arshita Singh</td>
                                                <td>10th</td>
                                                <td>95.4%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Ravi Kushwaha</td>
                                                <td>10th</td>
                                                <td>88.4%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Abhay Pathak</td>
                                                <td>10th</td>
                                                <td>88.2%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Krishna Mishra</td>
                                                <td>10th</td>
                                                <td>87.4%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Sakshi Kushwaha</td>
                                                <td>10th</td>
                                                <td>85.8%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Paras Vishwakarma </td>
                                                <td>8th</td>
                                                <td>89.8% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Krishna Kumar Gupta </td>
                                                <td>8th</td>
                                                <td>89.6% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Laxmi Yadav </td>
                                                <td>8th</td>
                                                <td>89.1%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Naveen Kumar Kushwaha </td>
                                                <td>8th</td>
                                                <td>87.5% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Yash Vishwakarma </td>
                                                <td>8th</td>
                                                <td>86.8% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Aksh Singh Thakur </td>
                                                <td>5th</td>
                                                <td>93.5% </td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Anshika Kushwaha </td>
                                                <td>5th</td>
                                                <td>89.2%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Anjali Singh </td>
                                                <td>5th</td>
                                                <td>89.2%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>Aryu Singh </td>
                                                <td>5th</td>
                                                <td>88.5% </td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>Riya Saket </td>
                                                <td>5th</td>
                                                <td>88%</td>
                                                <td>2024-25</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="result-list">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="sec-title mb-3" data-aos="fade-up" data-aos-duration={1000}>
                                    <span className="title">Result</span>
                                    <h2>Top Result</h2>
                                    <div className="divider">
                                        <span className="fa fa-mortar-board" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="autoplay">
                                    <SliderTopResult />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default HomeTopResult